
export default {
	name: 'VoidLabelConfirmationDialog',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		label: {
			type: Object,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		},
		hasReturnLabel: {
			type: Boolean,
			default: false
		},
		activeReturnLabelCount: {
			type: Number,
			default: 0
		},
		outboundLabelId: {
			type: String,
			default: null
		}
	},
	computed: {
		visible: {
			get() {
				return this.value;
			},
			set(val: boolean) {
				this.$emit('input', val);
			}
		},
		isMultiPackage(): boolean {
			return (this.label?.totalPackages || 1) > 1;
		},
		dialogTitle(): string {
			if (!this.label) return 'Void Label';
			if (this.label.isReturnLabel) return 'Void Return Label';
			if (this.isMultiPackage) return 'Void Shipment Labels';
			return 'Void Shipping Label';
		},
		primaryButtonText(): string {
			if (!this.label) return 'Void Label';
			if (this.label.isReturnLabel) return 'Void Return Label';
			if (this.isMultiPackage) return 'Void All Labels';
			return 'Void Label';
		}
	},
	methods: {
		closeDialog() {
			this.$emit('input', false);
			this.$emit('cancel');
		},

		confirmVoid() {
			this.$emit('confirm', this.label);
		},

		confirmVoidAll() {
			this.$emit('confirm-all', this.outboundLabelId);
		},

		formatCurrency(amount: number): string {
			return amount.toFixed(2);
		},

		formatDate(dateString: string): string {
			if (!dateString) return 'N/A';
			const date = new Date(dateString);
			return date.toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit'
			});
		},

		daysAgo(dateString: string): number {
			if (!dateString) return 0;
			const createdDate = new Date(dateString);
			const now = new Date();
			const diffTime = Math.abs(now.getTime() - createdDate.getTime());
			const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
			return diffDays;
		},

		getVoidWindow(): number {
			if (!this.label) return 30;
			const carrierCode = this.label.carrierCode?.toLowerCase() || '';
			// USPS: 28 days, UPS/FedEx: 30 days
			if (carrierCode.includes('usps') || carrierCode.includes('stamps')) {
				return 28;
			}
			return 30; // Default to 30 for UPS/FedEx
		},

		daysUntilVoidExpires(): number {
			if (!this.label) return 0;
			const daysSinceCreated = this.daysAgo(this.label.createdAt);
			const voidWindow = this.getVoidWindow();
			return Math.max(0, voidWindow - daysSinceCreated);
		},

		isVoidWindowClosing(): boolean {
			const daysLeft = this.daysUntilVoidExpires();
			return daysLeft <= 3 && daysLeft > 0;
		},

		getVoidWindowWarning(): string {
			const voidWindow = this.getVoidWindow();
			const carrierName = this.label?.carrierFriendlyName || 'This carrier';
			return `${carrierName} labels can be voided within ${voidWindow} days of creation`;
		},

		isPostBilledCarrier(): boolean {
			if (!this.label) return false;
			const carrierCode = this.label.carrierCode?.toLowerCase() || '';
			// UPS and FedEx are post-billed (only charged when scanned)
			return carrierCode.includes('ups') || carrierCode.includes('fedex');
		}
	}
};
